import { Injectable } from "@angular/core";
import { ILoginNotification, LoginNotificationCreator } from "@ramudden/models/login-notification";
import { Observable } from "rxjs";
import { ApiService } from "./api";

@Injectable({
    providedIn: "root",
})
export class LoginNotificationApi extends ApiService<
    ILoginNotification,
    LoginNotificationCreator,
    LoginNotificationCreator
> {
    override getRoute(): string {
        return "LoginNotifications";
    }

    restore$(id: number): Observable<void> {
        const url = `${super.getUrl()}/${id}/Restore`;
        return this.http.patch<void>(url, null);
    }
}
